import Repository from '@/repositories/repository'

const NavigationMenuRepository = {
  // TODO fix type
  async getNavigationMenu(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '10',
      ...queryParams
    }

    const response = await Repository('navigation_menu', 'content', params)

    return response.data.navigation_menu[0].menu_items
  },
  async getNavigationSecondMenu(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    const response = await Repository('menu_second_level', 'content', params)

    return response.data.menu_second_level
  },
  async getNavigationThirdMenu(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    const response = await Repository('menu_level_three', 'content', params)

    return response.data.menu_level_three
  },
  async getNavigationFourthMenu(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    const response = await Repository('menu_level_four', 'content', params)

    return response.data.menu_level_four
  },
  async getUpperNavigationMenu(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    const response = await Repository('upper_nav', 'content', params)

    return response.data.upper_nav
  },
  async getNavigationQuickLinks(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    const response = await Repository('quicklinks', 'content', params)

    return response.data.quicklinks
  },
  async getLowerNavData(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    const response = await Repository('lower_nav', 'content', params)

    return response.data.lower_nav
  }
}

export default NavigationMenuRepository
